import request from '@/utils/request'

//Fm电台列表
export function getRadioFmList(data) {
    return request({
        url: '/backend/radioFm/getRadioFmList',
        method: 'post',
        data: data
    })
}

//电台信息
export function radioFmInfo(data) {
    return request({
        url: '/backend/radioFm/radioFmInfo',
        method: 'post',
        data: data
    })
}

//创建/编辑电台
export function createUpdateRadioFm(data) {
    return request({
        url: '/backend/radioFm/createUpdateRadioFm',
        method: 'post',
        data: data
    })
}

//电台fm删除
export function radioFmDelete(data) {
    return request({
        url: '/backend/radioFm/radioFmDelete',
        method: 'post',
        data: data
    })
}

//获取课程下小节目录列表
export function getPeriodList(data) {
    return request({
        url: '/backend/radioFm/getPeriodList',
        method: 'post',
        data: data
    })
}

//获取筛选课程列表
export function screenCourseList(data) {
    return request({
        url: '/backend/radioFm/screenCourseList',
        method: 'post',
        data: data
    })
}

export function formatDate (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};
function padLeftZero (str) {
    return ('00' + str).substr(str.length);
}

